import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

/**
 * The house tooltip — the treatment the "How To Improve" tooltip introduced on
 * the Development Tier modal: a soft dark card on a dim hairline with a deep
 * shadow, no arrow, Inter at 11.5.
 *
 * Use this instead of a bare MUI `Tooltip` so every hover on a surface reads
 * the same. Anything a plain Tooltip accepts (placement, enterDelay, open,
 * componentsProps for a per-use override) passes straight through.
 */
const DosenTooltip: React.FC<TooltipProps> = ({ children, componentsProps, ...rest }) => (
  <Tooltip
    {...rest}
    componentsProps={{
      ...componentsProps,
      tooltip: {
        ...componentsProps?.tooltip,
        sx: {
          bgcolor: '#232323',
          border: '1px solid #2A2A2A',
          borderRadius: '8px',
          boxShadow: '0 12px 32px rgba(0,0,0,0.55)',
          p: '10px 12px',
          maxWidth: 320,
          fontFamily: 'Inter, sans-serif',
          fontSize: 11.5,
          fontWeight: 400,
          lineHeight: 1.45,
          color: '#B6B6B6',
          // Callers that need something bespoke can still override.
          ...(componentsProps?.tooltip as { sx?: object } | undefined)?.sx
        }
      }
    }}
  >
    {children}
  </Tooltip>
);

export default DosenTooltip;
